export default {"src":"https://fishbrain.com/_next/static/media/rhodeIsland.ba65d9c8.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};